import { render, staticRenderFns } from "./basicSetting.vue?vue&type=template&id=5d045174&scoped=true&lang=pug"
import script from "./basicSetting.vue?vue&type=script&lang=js"
export * from "./basicSetting.vue?vue&type=script&lang=js"
import style0 from "./basicSetting.vue?vue&type=style&index=0&id=5d045174&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d045174",
  null
  
)

export default component.exports